
export enum TimeIntervalEnum {

    NextMonth = -5, 
    NextWeek = -4,
    None = 0,
    QuarterOfHour = 1,
    Hour = 2,
    Day = 3,
    Week = 4,
    Month = 5,
    QuarterOfYear = 6,
    HalfYear = 10,
    Year = 11,
    AskedPeriod = 12,
    Minute = 13,
    FiveMinutes = 14,
    Seconds = 15

}
